import { useTranslation } from 'react-i18next';

export const ns = 'role-list-page';
export const useRoleListPageTranslation = () => useTranslation(ns);
export const ruRu = (__LOCALE_RU__ ? ({
  [ns]: {
    title: 'Роли',
    roles_found: 'Найдено: {{count}}',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [ns]: {
    title: 'Roles',
    roles_found: 'Found: {{count}}',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [ns]: {
    title: 'Roles',
    roles_found: 'Encontrados: {{count}}',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [ns]: {
    title: 'Funções',
    roles_found: 'Encontrado: {{count}}',
  },
}) : {}) as Record<string, unknown>;
